"use client";

import Image from "next/image";
import xcloseIcon from "public/icons/XCloseIcon.svg";
import { publishEventToSDK } from "@repo/sdk/publisher";
import {
  STATSIG_EVENTS,
  useStatsigClient,
  type RegisteredStatsigEvent,
} from "@repo/statsig";

export function DismissCloseButton() {
  const { logEvent } = useStatsigClient();

  const handleClose = () => {
    const event: RegisteredStatsigEvent = { eventName: "home_dismissed" };
    logEvent(event);
    logEvent({
      eventName: STATSIG_EVENTS.UI_DISMISSED,
      value: "home",
    });
    publishEventToSDK({ topic: "dismiss", data: "success" });
  };

  return (
    <button
      onClick={handleClose}
      aria-label="Close"
      className="px-4 text-gray-600 hover:text-gray-800 transition-colors flex items-center justify-center"
    >
      <Image src={xcloseIcon} alt="Close" width={24} height={24} unoptimized />
    </button>
  );
}
